import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ServiceResult } from '../../core/interfaces/service-result';
import { BaseCrudService } from '../../core/services/base-crud.service';
import { TransactionCreate } from '../dtos/transaction/transaction-create';
import { TransactionData } from '../interfaces/transaction/transaction-data';

@Injectable({
  providedIn: 'root',
})
export class TransactionHandlingService extends BaseCrudService<TransactionCreate, TransactionData> {

  baseUrl = this.runtimeConfig.transactionHandlingBackend;

  constructor() {
    super();
  }

  /**
   * Initializing a new child transaction on an existing transaction (capture, refund or void)
   * @param routeEndpoint Endpoint for the post request
   * @param type
   * @param parentId Id of the parent transaction
   * @param body
   */
  createChildTransaction(routeEndpoint: string, type: 'capture' | 'refund' | 'void' | 'credit', parentId: string, body: TransactionCreate): Observable<ServiceResult> {
    if (!routeEndpoint.startsWith('/')) { routeEndpoint = '/' + routeEndpoint; }
    if (!routeEndpoint.endsWith('/')) { routeEndpoint += '/'; }
    let headers = new HttpHeaders().set('content-type', 'application/json; charset=utf-8');
    return this.http.post<ServiceResult>(this.baseUrl + routeEndpoint + parentId + '/' + type, body, { headers: headers });
  }

  /**
   * Abruf eines spezifischen Datensatzes über die id als Routenparameter
   * @param routeEndpoint Endpunkt für den GET-Request (z.b. '/users')
   * @param id id (UUID) des Datensatzes
   */
  override findById(routeEndpoint: string, id: string): Observable<ServiceResult> {
    if (!routeEndpoint.startsWith('/')) { routeEndpoint = '/' + routeEndpoint; }
    if (!routeEndpoint.endsWith('/')) { routeEndpoint += '/'; }
    let headers = new HttpHeaders().set('content-type', 'application/json; charset=utf-8');
    return this.http.get<ServiceResult>(this.baseUrl + routeEndpoint + id, { headers: headers });
  }

}
